module.exports = {
  apiKey: "AIzaSyCvjvU4N-5q1PCwyqmcm2NfK8cFMsoonkU",
  authDomain: "flourigh-social.firebaseapp.com",
  databaseURL: "https://flourigh-social.firebaseio.com",
  projectId: "flourigh-social",
  storageBucket: "flourigh-social.appspot.com",
  messagingSenderId: "383652213367",
  appId: "1:383652213367:web:53f5ac99d48cc82d944c72",
  measurementId: "G-4DP07VGS3G"
}
